import React from 'react';
import '../style/newSolicitorForm.css';
import Dots from 'react-activity/lib/Dots';
import '../style/dots.css';
import FormResponseMessage from "./formResponseMessage";
import FormGroupTextInput from "./formGroupTextInput";
import Button from "./button";
import FormGroupSelectInput from "./formGroupSelectInput";
import FormGroupCheckBox from './General/formGroupCheckbox';
import FormGroupSelectMany from "./General/formGroupSelectMany";
import _ from 'lodash';
import CenteredDots from "./General/centeredDots";
import {isAdminUser, isAragUser} from "../helpers/functions";
import TobaFormHOC from "../containers/Tobas/tobaFormHOC";
import CustomModal from "./General/customModal";
import moment from "moment";

const NewUserForm = (props) => {
    const {onUnlockUser} = props;
    if(props.fetchingAragUserById){
        return <CenteredDots/>
    }
    
    return (
        <div className="row">
          <CustomModal
            isOpen={props.newUser.deleteUserModalOpen}
            content={<div>
              <form autoComplete={"off"} className="form-horizontal" onSubmit={(evt) => {
                  evt.preventDefault();
                  props.deleteAragUser({
                      userId: props.newUser.newUserFormData.id
                  })
              }}>
                <p>You are about to delete this user. Are you sure?
                </p>
                <div className="row">

                  <div className="col-sm-6 ">
                    <Button
                      wrapper="btn-wrapper-forForms"
                      btnType="submit" btnStyle={'btn btn-primary btn-xs sharp yellow'}
                      label="Confirm"/>
                    <Button
                      clickHandler={() => props.closeDeleteUserModal()}
                      wrapper="btn-wrapper-forForms"
                      btnType="button" btnStyle={'btn btn-primary btn-xs sharp white'}
                      label="Cancel"/>
                  </div>

                </div>
                { props.newUser.deletingAragUser && (
                  <div className={'col-sm-12'}>
                    <CenteredDots/>
                  </div>
                )}
              </form>
            </div>}
            handleClose={() => props.closeDeleteUserModal()}
          />
            <CustomModal
                contentClassname='tobas__toba-modal'
                isOpen={props.newUser.changePasswordModalOpen}
                content={<div>
                    <form className="form-horizontal" onSubmit={(evt) => props._changePassword(evt)}>
                        <FormGroupTextInput InputWrapper="col-sm-6" Label="Current Password" Type="password"
                                            Name="password" Value={props.newUser.changePasswordForm.password}
                                            HandleInputChange={(name ,value) =>
                                                props.changeNewUserNewPasswordForm({key: name, value: value})
                                            }
                        />
                        <FormGroupTextInput InputWrapper="col-sm-6" Label="New Password" Type="password"
                                            Name="newPassword" Value={props.newUser.changePasswordForm.newPassword}
                                            HandleInputChange={(name ,value) =>
                                                props.changeNewUserNewPasswordForm({key: name, value: value})
                                            }
                        />
                        <FormGroupTextInput InputWrapper="col-sm-6" Label="Retype New Password" Type="password"
                                            Name="reNewPassword"
                                            Value={props.newUser.changePasswordForm.reNewPassword}
                                            HandleInputChange={(name ,value) =>
                                                props.changeNewUserNewPasswordForm({key: name, value: value})
                                            }/>
                        <div className="row">

                            <div className="col-sm-6 col-sm-offset-3">
                                <Button
                                    wrapper="btn-wrapper-forForms"
                                    btnType="submit" btnStyle={'btn btn-primary btn-xs sharp yellow'}
                                    label="Confirm"/>
                                <Button
                                    clickHandler={() => props.closeChangePasswordModal()}
                                    wrapper="btn-wrapper-forForms"
                                    btnType="button" btnStyle={'btn btn-primary btn-xs sharp white'}
                                    label="Cancel"/>
                            </div>

                        </div>
                        {
                            props.newUser.posting?
                                <div className="col-sm-12">
                                    <CenteredDots/>
                                </div>
                                :
                                null
                        }
                    </form>
                </div>}
                handleClose={() => props.closeChangePasswordModal()}
            />
            <div className="col-sm-12 ">
                <div className="row">
                    <h2 className="solicitor-form-title col-sm-12">
                        {props.newUser.isNew ? "Create User" : (
                            isAragUser(props.userRoles) && !isAdminUser(props.userRoles)?
                                "Manage account":"Update User"
                        )}
                    </h2>
                </div>
                { (isAragUser(props.userRoles) && !isAdminUser(props.userRoles) )&& (
                    <Button clickHandler={() => props.openChangePasswordModal()}
                            wrapper="btn-wrapper"
                            btnType="button" btnStyle={'btn btn-primary btn-xs sharp yellow'}
                            label="Change Password"/>
                )}
                <form className="form-horizontal solicitor-form-wrapper " onSubmit={(evt) => props.handleSubmit(evt)}>
                    {props.newUser.unlockErrorMessage && (
                        <FormResponseMessage
                            Message={props.newUser.unlockErrorMessage}
                            CenterWrapper="col-sm-12"
                            MessageStyle="formResponseMessage-reject"
                        />
                    )}
                    <div className={"form-group"}>
                        <div className={"col-sm-12"}>
                            <Button
                                wrapper={"btn-wrapper"}
                                clickHandler={onUnlockUser}
                                btnType="button"
                                btnStyle={'btn btn-primary btn-xs sharp blue'}
                                label="Unlock User"
                                disabled={!(props.newUser.newUserFormData.isLockedOutUntilUtc
                                    && moment().isBefore(moment.utc(props.newUser.newUserFormData.isLockedOutUntilUtc).local()))}
                            />
                            {props.newUser.newUserFormData.isLockedOutUntilUtc
                            && moment().isBefore(moment.utc(props.newUser.newUserFormData.isLockedOutUntilUtc).local()) &&
                            <span>
                                        {`Locked until ${moment.utc(props.newUser.newUserFormData.isLockedOutUntilUtc).local().format("DD/MM/YYYY HH:mm:ss")}`}
                                {props.newUser.unlockingUser && (
                                    [
                                        " ",
                                        <Dots/>
                                    ]
                                )}
                                    </span>}
                        </div>
                    </div>
                    { isAdminUser(props.userRoles) && (
                        <FormGroupTextInput Name="username" Value={props.newUser.newUserFormData.username} Label="Username"
                                            autoComplete={"off"}
                                            Required={true}
                                            InputWrapper="col-sm-7 formGroup-textInput-input-wrapper"
                                            RightWrapper=""
                                            HandleInputChange={props.handleNewUser}/>
                    )}
                    { (props.newUser.newUserFormData.id && isAdminUser(props.userRoles) )&& (
                        <div className={'form-group'}>
                            <div className={'col-sm-7 col-sm-offset-3'}>
                                <Button
                                    wrapper="btn-wrapper"
                                    btnType="button"
                                    clickHandler={() => {
                                        props.resetAragUserPassword({userId: props.newUser.newUserFormData.id})
                                    }}
                                    btnStyle={'btn btn-primary btn-xs sharp white'}
                                    label="Reset Password"
                                />
                                {props.newUser.requestingResetPassword && (<Dots/>) }
                                {props.newUser.requestResetPasswordSuccessMessage && (
                                    <FormResponseMessage
                                        Message={props.newUser.requestResetPasswordSuccessMessage}
                                        CenterWrapper="col-sm-12 mt-15"
                                        MessageStyle="formResponseMessage-success"/>
                                )}
                                {props.newUser.requestResetPasswordFailMessage && (
                                    <FormResponseMessage
                                        Message={props.newUser.requestResetPasswordFailMessage}
                                        CenterWrapper="col-sm-12 mt-15"
                                        MessageStyle="formResponseMessage-reject"/>
                                )}
                            </div>
                        </div>
                    )}
                    <FormGroupTextInput Name="forename" Value={props.newUser.newUserFormData.forename} Label="Forename"
                                        Required={true}
                                        InputWrapper="col-sm-7 formGroup-textInput-input-wrapper"
                                        RightWrapper=""
                                        HandleInputChange={props.handleNewUser}/>
                    <FormGroupTextInput Name="surname" Value={props.newUser.newUserFormData.surname} Label="Surname"
                                        Required={true}
                                        InputWrapper="col-sm-7 formGroup-textInput-input-wrapper"
                                        RightWrapper=""
                                        HandleInputChange={props.handleNewUser}/>
                    <FormGroupTextInput Name="email" Value={props.newUser.newUserFormData.email} Label="Email"
                                        Type="text"
                                        Required={true}
                                        InputWrapper="col-sm-7 formGroup-textInput-input-wrapper"
                                        RightWrapper=""
                                        HandleInputChange={props.handleNewUser}/>
                    {props.newUser.isNew && isAdminUser(props.userRoles)  ?
                        <FormGroupTextInput Name="password" Value={props.newUser.newUserFormData.password}
                                            Label="Password" Type="password"
                                            Required={true}
                                            autoComplete={"off"}
                                            InputWrapper="col-sm-7 formGroup-textInput-input-wrapper"
                                            RightWrapper=""
                                            HandleInputChange={props.handleNewUser}/>
                        : null
                    }
                    {isAdminUser(props.userRoles) && (
                        <div>
                            <FormGroupSelectInput
                                Label="Group"
                                LeftWrapper="col-sm-3"
                                Value={props.newUser.newUserFormData.group}
                                Name="group"
                                HandleInputChange={ props._handleTextInputChange}
                                Options={props.groupOptions}
                                CenterWrapper="col-sm-7 formGroupSelectInput-select-wrapper"
                                RightWrapper="" Required={true}
                                SelectStyle={'form-control formGroupSelectInput-select'}
                            />
                            <FormGroupSelectInput
                                Label="Level"
                                LeftWrapper="col-sm-3"
                                Value={props.newUser.newUserFormData.level}
                                Name="level"
                                HandleInputChange={ props._handleTextInputChange}
                                Options={props.levelOptions}
                                CenterWrapper="col-sm-7 formGroupSelectInput-select-wrapper"
                                RightWrapper="" Required={true}
                                SelectStyle={'form-control formGroupSelectInput-select'}
                            />
                            <hr className="generalTab-hr"/>
                            <p><b>Assign Case Types & Damage Bands to user</b></p>
                            <FormGroupSelectMany
                                leftClassName={'col-sm-3'}
                                centerClassName={'col-sm-7'}
                                name={'caseTypes'}
                                options={props.caseTypesOptions}
                                handleChange={props._handleCaseTypesChange}
                                checkedItems={props.newUser.newUserFormData.caseTypes}
                                label={'Case types'}
                            />
                            <FormGroupSelectMany
                                leftClassName={'col-sm-3'}
                                centerClassName={'col-sm-7'}
                                name={'subCases'}
                                options={props.subCasesOptions}
                                handleChange={(name, value) => props._handleSubCasesPerCaseType(name, value)}
                                checkedItems={props.newUser.newUserFormData.subCases}
                                label={'Sub cases'}
                            />
                            <FormGroupSelectMany
                                leftClassName={'col-sm-3'}
                                centerClassName={'col-sm-7'}
                                name={'damages'}
                                options={props.damageBandsOptions}
                                handleChange={props._handleDamagesSelect }
                                checkedItems={props.newUser.newUserFormData.damages}
                                label={'Damages'}
                            />
                            <hr className="generalTab-hr"/>
                            <FormGroupCheckBox
                                leftClassName={'col-sm-3'}
                                centerClassName={'col-sm-7'}
                                checked={props.newUser.newUserFormData.allowedToEditOtherApplications}
                                label={'Allow to edit policies from different case types and damage bands than ' +
                                'the ones specified above'}
                                name={'allowedToEditOtherApplications'}
                                handleChange={props._handleCheckboxChange}
                            />
                            <FormGroupCheckBox
                                leftClassName={'col-sm-3'}
                                centerClassName={'col-sm-7'}
                                checked={props.newUser.newUserFormData.allowedToEditPremiumSettings}
                                label={'Allow to see & edit Premium Settings'}
                                name={'allowedToEditPremiumSettings'}
                                handleChange={props._handleCheckboxChange}
                            />
                            <FormGroupCheckBox
                                leftClassName={'col-sm-3'}
                                centerClassName={'col-sm-7'}
                                checked={props.newUser.newUserFormData.allowedToEditEditingSettings}
                                label={'Allow to see & edit Editing Settings'}
                                name={'allowedToEditEditingSettings'}
                                handleChange={props._handleCheckboxChange}
                            />
                            <FormGroupCheckBox
                                leftClassName={'col-sm-3'}
                                centerClassName={'col-sm-7'}
                                checked={props.newUser.newUserFormData.allowedToEditReferralSettings}
                                label={'Allow to see & edit Referral Settings'}
                                name={'allowedToEditReferralSettings'}
                                handleChange={props._handleCheckboxChange}
                            />
                            <FormGroupCheckBox
                                leftClassName={'col-sm-3'}
                                centerClassName={'col-sm-7'}
                                checked={props.newUser.newUserFormData.allowedToEditTobas}
                                label={'Allow to see & edit TOBAs'}
                                name={'allowedToEditTobas'}
                                handleChange={props._handleCheckboxChange}
                            />
                            <FormGroupCheckBox
                                leftClassName={'col-sm-3'}
                                centerClassName={'col-sm-7'}
                                checked={props.newUser.newUserFormData.allowedToEditArticles}
                                label={'Allow to see & edit Articles'}
                                name={'allowedToEditArticles'}
                                handleChange={props._handleCheckboxChange}
                            />
                            <FormGroupCheckBox
                                leftClassName={'col-sm-3'}
                                centerClassName={'col-sm-7'}
                                checked={props.newUser.newUserFormData.allowedToCreateInternalAlerts}
                                label={'Allow to create & edit Internal Alerts'}
                                name={'allowedToCreateInternalAlerts'}
                                handleChange={props._handleCheckboxChange}
                            />
                            <FormGroupCheckBox
                                leftClassName={'col-sm-3'}
                                centerClassName={'col-sm-7'}
                                checked={props.newUser.newUserFormData.allowedToEditApplicationPremiumSettings}
                                label={'Allow to edit Application Premium Settings'}
                                name={'allowedToEditApplicationPremiumSettings'}
                                handleChange={props._handleCheckboxChange}
                            />
                            <FormGroupCheckBox
                                leftClassName={'col-sm-3'}
                                centerClassName={'col-sm-7'}
                                checked={props.newUser.newUserFormData.disabled}
                                label={'Disabled'}
                                name={'disabled'}
                                handleChange={props._handleCheckboxChange}
                            />
                        </div>
                    )}
                    {
                        (props.newUser.badResponse.length > 0) ?
                            <div>
                                <FormResponseMessage LeftWrapper="col-sm-3"
                                                     CenterWrapper="col-sm-7 formResponseMessage-success-solicitor-group-wrapper"
                                                     MessageStyle="formResponseMessage-reject"
                                                     Message={ props.newUser.badResponse}/>
                            </div>
                            :
                            null
                    }
                    <div className="form-group">
                        <div className="col-sm-3">
                        </div>
                        <div className="col-sm-7">
                            <Button
                                wrapper="btn-wrapper-forForms"
                                btnType="submit"
                                btnStyle={'btn btn-primary btn-xs sharp yellow'}
                                label={props.newUser.isNew ? "Create User" : (
                                    isAragUser(props.userRoles)?
                                        "Update":"Update User"
                                )}
                            />
                            <Button
                                clickHandler={() => {
                                    props.clearNewUser();
                                    props.goBack()
                                }}
                                wrapper="btn-wrapper-forForms"
                                btnType="button"
                                btnStyle={'btn btn-primary btn-xs sharp white'}
                                label="Cancel"
                            />
                        </div>
                    </div>
                    { isAdminUser(props.userRoles) && (
                        <div className={'form-group'}>
                            <div className={'col-sm-7 col-sm-offset-3'}>
                                <Button
                                    clickHandler={() => {
                                        props.openDeleteUserModal();
                                    }}
                                    wrapper="btn-wrapper"
                                    btnType="button"
                                    btnStyle={'btn btn-primary btn-xs sharp blue'}
                                    label="Delete"
                                />
                            </div>
                        </div>
                    )
                    }
                    {
                        props.newUser.deleteAragUserResponseMessage && (
                            <FormResponseMessage
                                LeftWrapper="col-sm-3"
                                CenterWrapper="col-sm-7 formResponseMessage-success-solicitor-group-wrapper"
                                MessageStyle="formResponseMessage-reject"
                                Message={props.newUser.deleteAragUserResponseMessage}/>
                        )
                    }
                    {
                        (props.newUser.successMsg !== '') ?
                            <FormResponseMessage LeftWrapper="col-sm-3"
                                                 CenterWrapper="col-sm-7 formResponseMessage-success-solicitor-group-wrapper"
                                                 MessageStyle="formResponseMessage-success"
                                                 Message={props.newUser.successMsg}/>
                            :
                            null
                    }
                    {
                        props.newUser.posting ?
                            <div className="form-group">
                                <div className="col-sm-3">
                                </div>
                                <div className="col-sm-7">
                                    <div className="col-sm-5"></div>
                                    <Dots />
                                </div>
                            </div>
                            :
                            null

                    }
                    { props.newUser.deletingAragUser && (
                        <div className={'col-sm-12'}>
                            <CenteredDots/>
                        </div>
                    )}
                </form>
            </div>
        </div>
    )
};

export default NewUserForm;